import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import LocalizedStrings from 'react-localization';

function CompareBanner(props) {
  const getCompareListUrl = () => {
    const pathname = props.locale === 'ua' ? '/uk/kasko/compare' : '/kasko/compare';
    const params = props.location.search;
    return pathname + params;
  };

  const strings = new LocalizedStrings({
    ru: {
      add: 'Полис добавлено в сравнения!',
      go: 'перейти к сравнению',
    },
    ua: {
      add: 'Поліс добавлено до порівняння!',
      go: 'Перейти до порівняння',
    },
  });
  strings.setLanguage(props.locale);
  return (
    <div id="compare-message" className={props.compare.length > 0 ? 'add' : ''}>
      {/* <p>{props}</p> */}
      <div className="flex">
        <div className="ico">
          <svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M39.932 20.3501L39.898 20.368L34.1594 5.28725H36.7779C37.2474 5.28725 37.6281 4.88532 37.6281 4.38959C37.6281 3.89385 37.2474 3.49192 36.7779 3.49192H20.7779V0.897666C20.7779 0.40193 20.3972 0 19.9277 0C19.4582 0 19.0776 0.40193 19.0776 0.897666V3.48294H3.08608C2.61658 3.48294 2.23592 3.88487 2.23592 4.38061C2.23592 4.87635 2.61658 5.27828 3.08608 5.27828H5.81509L0.0680128 20.3501C0.0255048 20.4552 0.00244421 20.568 0 20.6822C0 24.8045 3.16493 28.1463 7.06908 28.1463C10.9732 28.1463 14.1382 24.8045 14.1382 20.6822C14.1357 20.568 14.1126 20.4552 14.0701 20.3501L8.33156 5.2693H19.0776V33.0251C15.0223 33.3483 11.8512 35.9515 11.8512 39.1023C11.8512 39.5981 12.2319 40 12.7014 40H27.1541C27.6236 40 28.0042 39.5981 28.0042 39.1023C28.0042 35.9515 24.8332 33.3483 20.7779 33.0251V5.2693H31.6344L25.9299 20.3501C25.8874 20.4552 25.8643 20.568 25.8618 20.6822C25.8618 24.8045 29.0268 28.1463 32.9309 28.1463C36.8351 28.1463 40 24.8045 40 20.6822C39.9976 20.568 39.9745 20.4552 39.932 20.3501ZM7.06483 26.3645C4.43167 26.3606 2.18916 24.3425 1.76833 21.5978H12.3273C11.9086 24.3291 9.68512 26.3431 7.06483 26.3645ZM12.0213 19.8025H2.1254L7.08183 6.77738L12.0213 19.8025ZM26.1509 38.2047H13.6961C14.3252 36.2747 16.9182 34.7846 19.9192 34.7846C22.9203 34.7846 25.5218 36.2747 26.1509 38.2047ZM32.8927 6.78636L37.8321 19.8025H27.9362L32.8927 6.78636ZM32.8927 26.3645V26.3734C30.2696 26.3513 28.0452 24.3327 27.6302 21.5978H38.1892C37.7683 24.3425 35.5258 26.3606 32.8927 26.3645Z" fill="white" />
          </svg>
          <div className="value">{props.compare.length}</div>
        </div>
        <div className="txt">
          <p>{strings.add}</p>
            <Link to={getCompareListUrl()} className="go-comparison">
              {strings.go}
              <svg width={6} height={10} viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L1 9" stroke="#0A7E3E" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /><path d="M1 1L5 5L1 9" stroke="#189851" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" /></svg>
            </Link>
        </div>
      </div>
    </div>
  );
}

export default withRouter(CompareBanner);
